module.exports = __webpack_public_path__ + "5f6ba40cbb5105e6bb78cabbad2a20cf.work2.svg";


//////////////////
// WEBPACK FOOTER
// ./containers/workWithUsPage/assets/work2.svg
// module id = HmTd
// module chunks = 0